export const isDebugToolsEnabled = () => {
  return localStorage.getItem('appdebug') || sessionStorage.getItem('appdebug');
};
